export const checkAndAddHttpPrefix = (url) => {
    if (url && url !== "") {
        //Check and add http prefix to url's using regex
        if (!/^https?:\/\//i.test(url)) {
            url = 'http://' + url;
        }
    }
    return url
}